export default {
    user: null,
    fetchingData: true,
    error:null,
    boards: {/* 
    id:{
        id,
        owner,
        name
    }
    */ },
    lists: {
        /* 
    id:{
        id,
        board,
        name
    }
    */
    },
    tasks:{
        /* 
    id:{
        id,
        list,
        title,
        completed
    }
    */
    },
}